__turbopack_context__.v({
  "cards": "OffersEmpty-module__sEYpCG__cards",
  "reader": "OffersEmpty-module__sEYpCG__reader",
});
